export default __webpack_public_path__ + "static/media/Western-US.9d697c29.jpg";